import React, { useEffect, useState } from "react";

const PaymentPOC: React.FC = () => {
  const [sessionId, setSessionId] = useState("");
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://test-gateway.mastercard.com/static/checkout/checkout.min.js";
    script.async = true;

    script.dataset.error = "errorCallback";
    script.dataset.cancel = "cancelCallback";

    document.body.appendChild(script);

    script.onload = (): void => {
      setIsScriptLoaded(true);
    };

    window.errorCallback = function (error) {
      console.warn("Payment Error:", error);
    };

    window.cancelCallback = function () {
      console.warn("Payment cancelled");
    };

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    if (isScriptLoaded && window.Checkout && sessionId) {
      window.Checkout.configure({
        session: { id: sessionId },
      });
    }
  }, [isScriptLoaded, sessionId]);

  //   const showEmbedded = () => {
  //     window.Checkout.showEmbeddedPage("#embed-target");
  //   };

  const showPaymentPage = (): void => {
    window.Checkout.showPaymentPage();
  };

  return (
    <div>
      <h2>Pay Now</h2>

      <input
        type="text"
        placeholder="Enter session ID"
        value={sessionId}
        data-dd-privacy="mask"
        onChange={(e) => setSessionId(e.target.value)}
        style={{
          padding: "8px",
          width: "400px",
          marginBottom: "10px",
          border: "1px solid gray",
        }}
      />

      {/* <div id="embed-target"></div>

      <button onClick={showEmbedded}>
        Pay with Embedded Page
      </button> */}

      <button
        style={{
          backgroundColor: "#2563eb",
          color: "#fff",
          border: "none",
          padding: "10px 18px",
          borderRadius: "6px",
          cursor: "pointer",
          fontSize: "14px",
          fontWeight: 500,
          boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
          transition: "all 0.2s ease",
          marginLeft: "10px",
        }}
        onClick={showPaymentPage}
      >
        Pay with Payment Page
      </button>
    </div>
  );
};

export default PaymentPOC;
